import React, { createContext, useCallback, useContext, useState } from 'react';
import { TeamPermission, TeamWithParty } from '../types/permissions';

type PermissionsContextState = {
  teamPermissions: TeamPermission[];
  ownedTeams: string[];
  allTeams: TeamWithParty[];
  setTeamPermissions: (permissions: TeamPermission[]) => void;
  setOwnedTeams: (teams: string[]) => void;
  setAllTeams: (teams: TeamWithParty[]) => void;
};

const PermissionsContext = createContext<PermissionsContextState | undefined>(undefined);
PermissionsContext.displayName = 'PermissionsContext';

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [teamPermissions, setTeamPermissionsState] = useState<TeamPermission[]>([]);
  const [ownedTeams, setOwnedTeamsState] = useState<string[]>([]);
  const [allTeams, setAllTeamsState] = useState<TeamWithParty[]>([]);

  const setTeamPermissions = useCallback((permissions: TeamPermission[]) => {
    setTeamPermissionsState(permissions);
  }, []);

  const setOwnedTeams = useCallback((teams: string[]) => {
    setOwnedTeamsState(teams);
  }, []);

  const setAllTeams = useCallback((teams: TeamWithParty[]) => {
    setAllTeamsState(teams);
  }, []);

  return (
    <PermissionsContext.Provider
      value={{ teamPermissions, ownedTeams, allTeams, setTeamPermissions, setOwnedTeams, setAllTeams }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export function usePermissions(): PermissionsContextState {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
}
